export default "__VITE_PUBLIC_ASSET__3cdf716f__"